import { LoaderFunctionArgs, json, redirect } from "@netlify/remix-runtime";
import { useLoaderData, useRouteError, Link, MetaFunction } from "@remix-run/react";
import { staticHeaders } from "~/lib/cache/static-headers";

import { getEvents } from "~/lib/cms/cms";
import { CalendarTypeSwitcher } from "~/components/calendar/calendar-type-switcher";
import { EventsByMonth } from "~/components/calendar/events-by-month";
import { CalendarViewSwitcher } from "~/components/calendar/calendar-view-switcher";

import { env } from "~/lib/env";
import { ErrorBoundaryy } from "~/templates/error-boundary";

export const meta: MetaFunction = () => {
  return [
    {
      title: "Ice Arena Events",
    },
    {
      name: "description",
      content: "Discover events happening at the Park District of Franklin Park Ice Arena.",
    },
  ];
};

export const loader = async ({ request, context, params }: LoaderFunctionArgs) => {
  const headers = await staticHeaders(request);

  const url = new URL(request.url);
  const page = url.searchParams.get("page");

  const apiUrl = env("BACKEND_API_URL");
  const res = await fetch(`${apiUrl}/events/ice-arena`);
  const events = await res.json();

  const pagination = {
    previous_page: "",
    next_page: "",
  };

  const eventsByMonth = events.reduce((acc, event) => {
    const month = new Date(event.start_datetime).toLocaleString("default", { month: "long" });
    if (!acc[month]) {
      acc[month] = [];
    }
    acc[month].push(event);
    return acc;
  }, {});

  const prevUrl = new URL(request.url);
  prevUrl.searchParams.set("page", pagination.previous_page);

  const nextUrl = new URL(request.url);
  nextUrl.searchParams.set("page", pagination.next_page);

  return json({ eventsByMonth, pagination, nextUrl, prevUrl }, { headers });
};

export default function Index() {
  const { eventsByMonth, pagination, nextUrl, prevUrl } = useLoaderData<typeof loader>();

  return (
    <main className="max-w-3xl mx-auto py-6">
      <div className="flex flex-col-reverse md:flex-row gap-3 flex-wrap justify-between items-center">
        <CalendarTypeSwitcher view="list" />
        <CalendarViewSwitcher view="list" calendarType="ice-arena" />
      </div>
      <div className="pt-6" data-searchable>
        <EventsByMonth eventsByMonth={eventsByMonth} pagination={pagination} nextUrl={nextUrl} prevUrl={prevUrl} />
      </div>
    </main>
  );
}

export const ErrorBoundary = ErrorBoundaryy;
